import React, { memo } from "react";

import { Outlet } from "react-router";

const AuthFeature = memo(() => {
  return (
    <div className="account-page">
      <div className="main-wrapper">
        <Outlet />
      </div>
    </div>
  );
});

AuthFeature.displayName = 'AuthFeature';

export default AuthFeature;
